import React, { useEffect, useState } from "react";
import { Container, Tabs, Tab } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { ProductListing } from "../../Data/data";
import SlickSliderComp from "../../components/SlickSliderComp/SlickSliderComp";
import Specification from "./Specification/Specification";
import Information from "./AdditionalInformation/Information";
import Disclaimer from "./Disclaimer/Disclaimer";
import Reviews from "./ProductReviews/Reviews";
import ProductZoom from "./ProductZoom/ProductZoom";
import "react-toastify/dist/ReactToastify.css";
import { useDispatch, useSelector } from "react-redux";
import {
  PRODUCT_LIST,
  VIEW_PRODUCT,
  VIEW_REVIEW,
} from "../../Redux/SagaAction/actions";
import Loader from "../../components/Loader";
import {
  Link,
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Slider from "react-slick";
import ProductCardCM from "../../components/ProductCardCM/ProductCardCM";
import { decrypt } from "../../Crypto/function";
import BlackLogo from "../../assets/images/BlackLogo.svg";
import ActionIcon from "../../assets/icons/actionIcon.svg";

const ProductDetail = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [size, setSize] = useState(null);
  const [color, setColor] = useState(null);
  const { title: CategoryId, productId: mainCatalogId } = useParams();
  const { state } = useLocation();
  let {
    productsList,
    isLoading,
    viewProduct,
    ProductlistLoading,
    ProductDetailLoading,
    reviewLoading,
    loading,
    productId,
  } = useSelector((state) => state.ProductSlice);
  const { isMainCLoading, isSubCLoading } = useSelector(
    (e) => e.GetCategorySlice
  );
  const {addTCLoader}= useSelector((e)=>e.AddToCartSlice)
  let [searchParams, setSearchParams] = useSearchParams();
  const [viewId, setViewId] = useState(null);
  const [viewSizeId, setViewSizeId] = useState(null);
  const settings = {
    dots: false,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          dots: true,
          arrows: false,
          infinite: false,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          dots: true,
          arrows: false,
          infinite: false,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows: false,
          infinite: false,
        },
      },
    ],
  };
  useEffect(() => {
    if (mainCatalogId) {
      dispatch({
        type: VIEW_PRODUCT,
        payload: decrypt(mainCatalogId),
        callback: (e) => {
          setViewId(state?.spcVariant || e?.addVariant?.[0]?._id);
          setViewSizeId(
            state?.wishListSizeID ||
              e?.addVariant?.[0]?.variantList?.[0]?.sizeId
          );
          // setSearchParams({"sizeID":e?.addVariant?.[0]?.variantList?.[0]?.sizeId,"viewId": e?.addVariant?.[0]?._id})
        },
      });
      dispatch({
        type: PRODUCT_LIST,
        payload: { categoryId: decrypt(CategoryId) },
      });
    }
  }, [mainCatalogId]);

  const AddedToCart = (title) => {
    toast.success(`${title} product Added to cart !`, {
      position: toast.POSITION.TOP_RIGHT,
    });
  };
  const existToCart = (title) => {
    toast.warn(`${title} already added to cart!`, {
      position: toast.POSITION.TOP_RIGHT,
    });
  };
  const CodeCopied = (code) => {
    toast.success(`${code} code copied !`, {
      position: toast.POSITION.TOP_RIGHT,
    });
  };
  const existCode = () => {
    toast.warn(`please copy again`, {
      position: toast.POSITION.TOP_RIGHT,
    });
  };
  const AddedToWishlist = (title) => {
    toast.success(`${title} added to Wishlist!`, {
      position: toast.POSITION.TOP_RIGHT,
    });
  };

  return (
    <>
      {(isMainCLoading || isSubCLoading || addTCLoader || isLoading || ProductlistLoading) && <Loader />}
      {viewProduct === null && (
        <div className="nullProduct">
          <div className="site-logo-box">
            <img src={BlackLogo} alt="logo" className="Blacklogo" />
          </div>
          <img src={ActionIcon} alt="logo" className="action-icon" />
          <h4> Looking for something? </h4>
          <p>
            {" "}
            We're sorry. The Web address you entered is not a functioning page
            on our site.{" "}
          </p>
          <Link to="/"> Click here to go back to the Swanee home page</Link>
        </div>
      )}

      <div className="pb-50">
        {viewProduct && productsList && (
          <ProductZoom
            viewId={viewId}
            setViewId={setViewId}
            viewSizeId={viewSizeId}
            setViewSizeId={setViewSizeId}
            viewProduct={viewProduct}
            AddedToCart={AddedToCart}
            existToCart={existToCart}
            CodeCopied={CodeCopied}
            existCode={existCode}
            AddedToWishlist={AddedToWishlist}
            setColor={setColor}
            setSize={setSize}
            color={color}
            size={size}
          />
        )}
      </div>

      {viewProduct && (
        <div className="product-features ptb">
          <Container>
            <Tabs defaultActiveKey="specifications" id="noanim-tab-example">
              <Tab eventKey="specifications" title="Specifications">
                <Specification  />
              </Tab>
              {/* <Tab
              eventKey="additionalinformation"
              title="Additional Information"
            >
              <Information/>
            </Tab> */}
              {/* <Tab eventKey="disclaimer" title="Disclaimer">
              <Disclaimer/>
            </Tab> */}
              <Tab eventKey="reviews" title="Reviews">
                <Reviews />
              </Tab>
            </Tabs>
          </Container>
        </div>
      )}
      
      {productsList?.length !== 0 && viewProduct && (
        <div className="similar-product ptb">
          <Container>
            <div className="title-wraper">
              <h2>Similar Products</h2>
              <div
                className="custom-link view-link"
                onClick={() => navigate(`/productlisting/Similar Products`)}
              >{`${t("button.viewbtn")}`}</div>
            </div>
            <div className="custom-slider">
              <Slider
                {...settings}
                slidesToShow={
                  productsList?.length > 4 ? 4 : productsList?.length
                }
                slidesToScroll={
                  productsList?.length > 4 ? 4 : productsList?.length
                }
              >
                {productsList?.map((list, index) => {
                  return <ProductCardCM data={list} productDetails />;
                })}
              </Slider>
            </div>
          </Container>
        </div>
      )}
    </>
  );
};

export default ProductDetail;
